<template>
  <div class="row">
    <div class="col-12">
      <div>
        <h2 class="font-weight-bold m-0">{{influencer.name}}</h2>
        <p class="text-muted text-uppercase">Influencer profile summary</p>
      </div>
      <div class="row">
        <div class="col-sm-8">
          <div class="table-responsive mt-3">
            <table class="table table-striped">
              <tr>
                <th>ID</th>
                <td>{{influencer.id}}</td>
              </tr>
              <tr>
                <th>Firstname</th>
                <td>{{influencer.firstname}}</td>
              </tr>
              <tr>
                <th>Lastname</th>
                <td>{{influencer.lastname}}</td>
              </tr>
              <tr>
                <th>Name</th>
                <td>{{influencer.name}}</td>
              </tr>
              <tr>
                <th>Nickname</th>
                <td>{{influencer.nickname}}</td>
              </tr>
              <tr>
                <th>Location</th>
                <td>{{influencer.location}}</td>
              </tr>
              <tr>
                <th>Category</th>
                <td>{{category[influencer.category_id]}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>


      <div class="mt-4">
        <h5 class="font-weight-bold">Influencer profiles:</h5>
        <div class="mt-2">
          <p class="mb-1" v-for="author in authors">
            <a v-bind:href="author.url" target="_blank">{{author.url}}</a>
          </p>
        </div>
      </div>

      <div class="mt-5">
        <h5 class="font-weight-bold">InfluTool link:</h5>
        <a v-bind:href="'https://influtool.com/panel#/project/' + influencer.id + '/influencer'">https://influtool.com/panel#/project/{{influencer.id}}/influencer</a>
      </div>

   </div>



  </div>
</template>

<script>
  export default {
    name: "influencer",
    data() {
      return {
        influencer: {},
        authors: [],
        category: {},
        apiHost: this.$appSettings.getSetting('host')
      }
    },
    methods: {
      getInfo() {
        this.$http.get(this.apiHost + 'influencers/show', {
          params: {
            token: this.$auth.getToken(),
            id: this.$route.params.id
          }
        }).then(function(data) {
          if (data.body.success) {
            this.influencer = data.body.data.influencer;
            this.authors = data.body.data.author;
          }
        });
      },
      getInfluencerCategory() {
        this.$http.get(this.apiHost + 'influencers/category/get', {
          params: {
            token: this.$auth.getToken()
          }
        }).then(response => {
          if (response.body.success) {
            this.category = response.body.data.list;
          }
        });
      },

    },
    created: function() {
      this.getInfo();
      this.getInfluencerCategory()
    }
  }
</script>

<style scoped>
  title {
    margin: 20px 0 30px;
  }

  h4 {
    margin: 35px 0 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/influencer/Influencer.vue